import { useQuery } from "@tanstack/react-query";
import { uploadService, FileStatusItem } from "../../../api/services/uploadService";

export const fileStatusKeys = {
  all: ["fileStatus"] as const,
  list: (docType: string, datetime: string) =>
    [...fileStatusKeys.all, "list", docType, datetime] as const,
};

export function useFileStatus(docType: string, datetime: string, enabled: boolean = true) {
  return useQuery({
    queryKey: fileStatusKeys.list(docType, datetime),
    queryFn: async (): Promise<FileStatusItem[]> => {
      if (!docType) {
        return [];
      }

      const response = await uploadService.getFileStatus({
        datetime,
        docType,
      });
      return response.data || [];
    },
    enabled: enabled && !!docType,
    staleTime: 1000 * 60 * 2,
    refetchInterval: (query) => {
      const data = query.state.data as FileStatusItem[] | undefined;
      const hasProcessingFiles = data?.some(
        (item) => item.status === "processing"
      );
      return hasProcessingFiles ? 5000 : false;
    },
    retry: 1,
  });
}
